export default __webpack_public_path__ + "static/media/ID.96de835b.svg";